import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, UpdateCommand } from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

const {
  REACT_APP_SUPPORTED_LOCATION_TABLE_REGION,
  REACT_APP_SUPPORTED_LOCATION_TABLENAME,
} = process.env;

const handler = async (location, { rejectWithValue }) => {
  try {
    const { credentials } = await fetchAuthSession();

    const docClient = DynamoDBDocumentClient.from(
      new DynamoDBClient({
        region: REACT_APP_SUPPORTED_LOCATION_TABLE_REGION,
        credentials,
      })
    );

    const now = new Date().toISOString();

    const result = await docClient.send(new UpdateCommand({
      TableName: REACT_APP_SUPPORTED_LOCATION_TABLENAME,
      Key: {
        state: location.state,
        municipality: location.municipality,
      },
      UpdateExpression: 'SET #country = :country, #country_code = :country_code, #label = :label, #enabled = :enabled, #created = if_not_exists(#created, :now), #modified = :now, #normalized_location_key = :nlk',
      ExpressionAttributeNames: {
        '#country': 'country',
        '#country_code': 'country_code',
        //'#postal_code': 'postal_code',
        '#label': 'label',
        '#enabled': 'enabled',
        '#created': 'created',
        '#modified': 'modified',
        '#normalized_location_key': 'normalized_location_key',
      },
      ExpressionAttributeValues: {
        ':country': location.country,
        ':country_code': location.country_code,
        //':postal_code': location.postal_code,
        ':label': location.label,
        ':enabled': true,
        ':now': now,
        ':nlk': `${location.country_code.toLowerCase()}|${location.state.toLowerCase()}|${location.municipality.toLowerCase()}`,
      },
      ReturnValues: 'ALL_NEW',
    }));

    const item = result.Attributes;
    if (process.env.NODE_ENV !== 'production') {
      console.log('services.locations.createSupportedLocation@handler', 'created:', item);
    }

    return { location: item };

  } catch (error) {
    console.error('services.locations.createSupportedLocation@handler', error);
    return rejectWithValue(error.message || error);
  }
};


const pending = (state) => ({ ...state, creating: true });
const fulfilled = (state, action) => ({
  ...state,
  creating: false,
  lists: [...state.lists, action.payload.location],
});
const rejected = (state) => ({ ...state, creating: false });

export default { handler, pending, fulfilled, rejected };
